import * as React from "react";

import { BlogCard } from "tabler-react";

class JobDetailsBlogCard extends React.Component {
  render() {
    return (
      <BlogCard
        title="4 steps of Right Hiring"
        postUrl="https://blog.hirexl.in/2023/03/01/4-steps-of-right-hiring/"
        description="As more and more workers opt through necessity or preference to work from home, their managers are hustling to give them the direction and support they need…"
        avatarImgSrc="https://blog.hirexl.in/wp-content/uploads/2021/03/1614448740237-150x150.jpeg"
        authorName="Swati Sinha"
        date="Mar 4, 2021"
        imgSrc="https://blog.hirexl.in/wp-content/uploads/2021/03/lucas-law-ecELcxmJTk4-unsplash.jpg"
        imgAlt="4 steps of Right Hiring"
      />
    );
  }
}

export default JobDetailsBlogCard;
